var _rect, _g, _rect2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "#b22234"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3.08,
    width: 60,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9.24,
    width: 60,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15.4,
    width: 60,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    y: 21.56,
    width: 60,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    y: 27.72,
    width: 60,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    y: 33.88,
    width: 60,
    height: 3.08
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17.6,
    fill: "#3c3b6e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2.4,2.4 3.2,4.8 0.8,3.2 4,3.2 1.6,4.8"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 4.8
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 9.6
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 14.4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 19.2
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    y: 3.52
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 4.8,
    y: 3.52
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 9.6,
    y: 3.52
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 14.4,
    y: 3.52
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 19.2,
    y: 3.52
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    y: 7.04
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 4.8,
    y: 7.04
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 9.6,
    y: 7.04
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 14.4,
    y: 7.04
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 19.2,
    y: 7.04
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    y: 10.56
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 4.8,
    y: 10.56
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 9.6,
    y: 10.56
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 14.4,
    y: 10.56
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 19.2,
    y: 10.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/us-flag.e79be4d35fa3ada5a1c8de307c2be2ee.svg";
export { ForwardRef as ReactComponent };